<template>
  <div id="age-risk-codes-create">
    <div class="mb-4">
      <h1>Risk Codes</h1>
    </div>

    <risk-code-form v-model="model" ref="form" page-title="Create Risk Code" />

    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-start">
          <vs-button
            @click="$router.push({ name: 'risk-codes.list' })"
            class="my-4"
          >
            Cancel
          </vs-button>
        </div>
      </div>
      <div class="vx-col sm:w-1/2">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            @click="create"
            class="my-4"
            color="light"
          >
            Create
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RiskCodeForm from '@/views/pages/risk-codes/RiskCodeForm';
import NotificationMixin from '@/components/mixins/NotificationMixin';

export default {
  name: 'RiskCodeCreate',
  components: {
    RiskCodeForm
  },
  mixins: [NotificationMixin],
  data() {
    return {
      model: {}
    };
  },
  methods: {
    getParams() {
      const params = {
        ...this.model
      };

      const references = [
        'RiskCodeReferenceOne_FK',
        'RiskCodeReferenceTwo_FK',
        'RiskCodeReferenceThree_FK',
        'RiskCodeReferenceFour_FK',
        'RiskCodeReferenceFive_FK',
        'RiskCodeReferenceSix_FK'
      ];

      references.forEach(ref => {
        if (!params[ref]) {
          return true;
        }

        params[ref] = params[ref].id;
      });

      return params;
    },
    async create() {
      if (!this.$refs.form.validate()) {
        this.notifyError('Not all required fields have been provided');
        return false;
      }

      const params = this.getParams();

      //  return;
      try {
        const { data } = await this.$api.riskCode.create(params);
        this.notifySuccess('Risk Code created');
        this.$router.back();
      } catch (e) {
        this.notifyError('Risk code failed to be created');
        console.error(e);
      }
    }
  }
};
</script>

<style scoped>
</style>
